module.exports = __webpack_public_path__ + "img/avatar.bfe48d2c.jpg";